import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { OrganizationInterface } from '@sport-activities/sdk';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { OrganizationService } from '~/core/services/organization/organization.service';

export const OrganizerResolver: ResolveFn<OrganizationInterface> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  router: Router = inject(Router),
  organizationService: OrganizationService = inject(OrganizationService)
): Observable<OrganizationInterface> => {
  return organizationService.getOrganizationById(route.paramMap.get('id')).pipe(
    catchError((error) => {
      router.navigateByUrl('/404');

      return throwError(() => error);
    })
  );
};
